"use client";
import { useProps } from "../../../core/MantineProvider/use-props/use-props.mjs";
import { MenuRadioGroupContext } from "./MenuRadioGroup.context.mjs";
import { useUncontrolled } from "@mantine/hooks";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Menu/MenuRadioGroup/MenuRadioGroup.tsx
function MenuRadioGroup(_props) {
	const { value, defaultValue, onChange, children } = useProps("MenuRadioGroup", null, _props);
	const [_value, setValue] = useUncontrolled({
		value,
		defaultValue,
		finalValue: null,
		onChange
	});
	return /* @__PURE__ */ jsx(MenuRadioGroupContext, {
		value: {
			value: _value,
			onChange: (next) => setValue(next)
		},
		children
	});
}
MenuRadioGroup.displayName = "@mantine/core/MenuRadioGroup";
//#endregion
export { MenuRadioGroup };

//# sourceMappingURL=MenuRadioGroup.mjs.map